module.exports = __webpack_public_path__ + "img/nodata.fa342acc.png";